<a
    class="w-full flex flex-col items-center justify-center hover:bg-blurple rounded-lg"
    routerLink="/settings"
    routerLinkActive="!bg-blurple-dark"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    #link="routerLinkActive"
    pTooltip="Settings"
    tooltipPosition="right">
    <fa-icon
        class="text-18 text-white"
        [icon]="faGear"
        [ngClass]="{ hidden: isHovered || link.isActive }" />
    <fa-icon
        class="text-18 text-white"
        [icon]="faGearSolid"
        [ngClass]="{ hidden: !isHovered && !link.isActive }" />
</a>
